import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-mb-3" }
const _hoisted_2 = { class: "p-grid" }
const _hoisted_3 = { class: "p-col-12" }
const _hoisted_4 = {
  key: 0,
  class: "p-col-2 container-image"
}
const _hoisted_5 = {
  key: 1,
  class: "p-col-2 container-image"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "image-overlay" }
const _hoisted_8 = {
  key: 2,
  class: "p-col-2 container-image"
}
const _hoisted_9 = {
  key: 3,
  class: "p-col-2 container-image"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "image-overlay" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SystemThemeUploadForm = _resolveComponent("SystemThemeUploadForm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('Squeeze.System.ImageUploadDescription')), 1)
    ]),
    _createVNode(_component_SystemThemeUploadForm, {
      selectedFiles: _ctx.files,
      onFileUploader: _ctx.fileUploader,
      onDeleteThemeFile: _ctx.deleteThemeFile
    }, null, 8, ["selectedFiles", "onFileUploader", "onDeleteThemeFile"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('Squeeze.System.CurrentImages')), 1)
      ]),
      (_ctx.loadingLogo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("i", {
              class: "mdi mdi-spin mdi-loading",
              style: {"fontSize":"5rem"}
            }, null, -1)
          ]))]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("img", {
              src: _ctx.urlClientLogo,
              alt: "Client Logo",
              class: "image"
            }, null, 8, _hoisted_6),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('Squeeze.System.LoginLogoImage')), 1)
          ])),
      (_ctx.loadingLogo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("i", {
              class: "mdi mdi-spin mdi-loading",
              style: {"fontSize":"5rem"}
            }, null, -1)
          ]))]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("img", {
              src: _ctx.urlClientBackground,
              alt: "Background Image",
              class: "image"
            }, null, 8, _hoisted_10),
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('Squeeze.System.LoginBackgroundImage')), 1)
          ]))
    ])
  ], 64))
}